<template>
  <div class="portrait-prompt-panel">
    <div class="portrait-prompt-panel-component hidden">
      <div class="component-background" @click="close" />
      <slide-y-down-transition :duration="1000">
        <div
          v-show="show"
          class="wrapper"
          :class="$store.state.theme"
          @click="close"
        >
          <div class="close">
            <button class="delete is-large" @click="close" />
          </div>
          <p style="margin-bottom: 10px">
            <img src="/img/home2/edit-tools.svg" />
          </p>
          <p class="is-size-5">{{ $t("view-in-portrait") }}</p>
          <br />
          <span class="button is-warning is-rounded" @click="close">
            {{ this.$t("okay") }}
          </span>
        </div>
      </slide-y-down-transition>
    </div>
  </div>
</template>


<script>
import EventBus from "../eventBus.js";

export default {
  name: "PortraitPromptPanel",
  components: {},
  data() {
    return {
      show: false,
      done: false, // only show once then done
    };
  },
  mounted() {
    EventBus.$on("PORTRAIT_PROMPT", (state) => {
      if (this.done) return;
      if (state) {
        // block duplicate events, e.g. on screen resize
        if (!this.show) {
          this.show = true;
          this.done = true;
          setTimeout(() => this.close(), 3000);
        }
      } else this.close();
    });
  },
  methods: {
    close() {
      this.show = false;
      var name = ".portrait-prompt-panel-component";
      this.hideComponent(name);
      //   setTimeout(() => this.hideComponent(name), 1000);
    },
  },
};
</script>

<style scoped>
.hidden {
  display: none;
}
.component-background {
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.25);
  z-index: 2;
}
img {
  transform: rotate(270deg);
  height: 150px;
  width: 150px;
}
.wrapper {
  position: absolute;
  bottom: 0px;
  width: 100vw;
  backdrop-filter: blur(8px);
  background-color: rgba(255, 255, 255, 0.85);
  padding: 18px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.35);
  z-index: 5;
  border-top-right-radius: 25px;
  border-top-left-radius: 25px;
}
.dark {
  background-color: rgba(17, 34, 51, 0.85);
  color: white;
}
/* .dark .subtitle {
  color: white;
} */
.close {
  position: absolute;
  right: 0;
  top: 0;
  opacity: 0.6;
  padding: 10px;
  /* color: #f5d252;
  text-shadow: 1px 0px 1px rgba(0, 0, 0, 0.3); */
}
</style>